if (!customElements.get('gift-with-purchase')) {
  customElements.define('gift-with-purchase', class GiftWithPurchase extends HTMLElement {
    constructor() {
      super();
      this.configuration = JSON.parse(this.querySelector('template[data-configuration]').content.textContent);
      this.gifts = this.configuration.gifts;
      this.eligibleCustomer = true;
    }
    
    connectedCallback() {
      if (!this.gifts?.length) return;
      this.init();
    }

    matchUtm(actualPair, expectedPair, strategy = 'EQUALS') {
      if (!actualPair || !expectedPair) return false;
      const [actualKey, ...actualValArr] = actualPair.split('=');
      const [expectedKey, ...expectedValArr] = expectedPair.split('=');
      if (actualKey !== expectedKey) return false;

      const actualVal = actualValArr.join('=').replace('+', ' ');
      const expectedVal = expectedValArr.join('=').replace('+', ' ');

      if (strategy === 'EQUALS') return actualVal === expectedVal;
      if (strategy === 'CONTAINS') return actualVal.includes(expectedVal);
      return false;
    }

    init() {
      window.addItem = window.addItem || {};
      window.removeItem = window.removeItem || {};

      const urlParams = new URLSearchParams(window.location.search);
      const utmKey = this.configuration.utm?.split('=')[0];
      const utmValue = this.configuration.utm?.split('=')[1]?.replace('+', ' ');
      const strategy = this.configuration.utm_validation_strategy || 'EQUALS';

      if (utmKey && utmValue && urlParams.has(utmKey)) {
        const actualValue = urlParams.get(utmKey).replace('+', ' ');
        const actualPair = `${utmKey}=${actualValue}`;
        if (this.matchUtm(actualPair, this.configuration.utm, strategy)) {
          sessionStorage.setItem('utm_code', actualPair);
        }
      }

      if (this.configuration.eligibleCustomers.length) {
        const customerMatch = this.configuration.eligibleCustomers.some(c => c.includes(this.configuration.currentCustomer));
        if (!customerMatch) this.eligibleCustomer = false;
      }

      const inCart = this.configuration.cart.items.find(item =>
        this.gifts.find(gift => item.product_id === gift.id && item.properties['_free_gift'] === this.configuration.id)
      );

      const isEligible = this.checkEligibility() && this.eligibleCustomer && this.gifts.some(g => g.available);

      if (isEligible && inCart) {
        window.removeItem[this.configuration.id] = false;
      } else if (isEligible && !inCart) {
        window.removeItem[this.configuration.id] = false;
        const eligibleGift = this.gifts.find(gift => gift.variants.length < 2 && this.gifts.length < 2 && this.configuration.allowRemoval === 'false');
        if (eligibleGift) {
          this.add(eligibleGift.variants[0].id);
          return;
        }
        this.innerHTML = `
          ${this.gifts.map(gift => `
            <intersection-loader data-url="/products/${gift.handle}" data-section-id="free-gift-item" class="sp-aspect-[112/23] sp-block sp-w-full sp-bg-gray-100"></intersection-loader>
          `).join('')}`;
      } else if (!isEligible && !inCart) {
        if (window.removeItem[this.configuration.id] === true) {
          this.innerHTML = `<div class="sp-bg-pakaBeige sp-p-4 sp-text-center empty:hidden">${this.configuration.removedMessage}</div>`;
        }
      } else if (!isEligible && inCart) {
        const giftInCart = this.configuration.cart.items.find(item =>
          this.gifts.find(gift => item.product_id === gift.id && item.properties['_free_gift'] === this.configuration.id)
        );
        if (giftInCart) this.remove(giftInCart.key);
      }
    }

    checkEligibility() {
      const { validationType, minPurchase, requiredProducts, utm, startDate, endDate, utm_validation_strategy } = this.configuration;
      const now = new Date();
      const withinDateRange = (!startDate || new Date(startDate) <= now) && (!endDate || now <= new Date(endDate));
      if (!withinDateRange) return false;

      const hasRequiredProduct = this.configuration.cart.items.some(item =>
        requiredProducts.some(product => item.product_id === product.id)
      );

      const meetsThreshold = Number(minPurchase) && this.configuration.cart.total_price >= parseInt(minPurchase, 10);

      const storedUtmPair = sessionStorage.getItem('utm_code');
      const hasUTM = this.matchUtm(storedUtmPair, utm, utm_validation_strategy || 'EQUALS');

      switch (validationType) {
        case 'Required Product in Cart':
          return hasRequiredProduct;
        case 'Required Purchase Threshold':
          return meetsThreshold;
        case 'Required UTM Parameter':
          return hasUTM;
        case 'Both: Required Product in Cart & Required Purchase Threshold':
          return hasRequiredProduct && meetsThreshold;
        case 'Both: Required Product in Cart & Required UTM Parameter':
          return hasRequiredProduct && hasUTM;
        case 'Both: Required Purchase Threshold & Required UTM Parameter':
          return meetsThreshold && hasUTM;
        case 'All: Required Purchase Threshold & Required UTM Parameter & Required Product in Cart':
          return hasRequiredProduct && meetsThreshold && hasUTM;
        default:
          return false;
      }
    }

    remove(itemKey) {
      const minicart = document.querySelector('mini-cart');
      if (!minicart) return;
      window.removeItem[this.configuration.id] = true;
      minicart.classList.add('loading');
      minicart.updateQty(itemKey, 0)
        .then(res => {
          if (!res) return;
          minicart.updateCartHtml(res).then(() => {
            minicart.querySelector('form').scrollTo({ top: 0, left: 0, behavior: 'auto' });
          });
        })
        .finally(() => minicart.classList.remove('loading'));
    }

    add(idToAdd) {
      const minicart = document.querySelector('mini-cart');
      window.addItem[this.configuration.id] = true;
      if (!minicart) return;
      minicart.classList.add('loading');
      minicart.addToCart(idToAdd, null, null, { _free_gift: this.configuration.id })
        .then(() => minicart.classList.remove('loading'));
    }
  });
}
